import React from "react";
import EditContainer from "../EditContainer";
import { PAGES } from "../../../util/constants/pages";

export const PreApprovalEditContainer = () => (
  <EditContainer page={PAGES.PRE_APPROVAL} />
);
